import { render, staticRenderFns } from "./StagnantOverview.vue?vue&type=template&id=133e9439&scoped=true&"
import script from "./StagnantOverview.vue?vue&type=script&lang=js&"
export * from "./StagnantOverview.vue?vue&type=script&lang=js&"
import style0 from "./StagnantOverview.vue?vue&type=style&index=0&id=133e9439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e9439",
  null
  
)

export default component.exports